import styled from 'styled-components';

export default styled.div`
  .init-message-wrap {
    width: 340px;
    height: 232px;
    background: #ffffff;
    border: 1px solid #666464;
    padding: 8px 24px;
    display: flex;
    flex-direction: column;
    .message-content {
      height: 106px;
      font-size: 14px;
      background: #f9f9f9;
      padding: 16px;
      color: #222222;
      overflow-y: auto;
    }
  }
`;
